/* eslint-disable class-methods-use-this */
export default class LeftRight {
    constructor() {
        const containers = document.querySelectorAll('.js-leftright');
        containers.forEach((container, index) => {
            const content = container.querySelector('.leftright-content');
            const contentHeight = content?.offsetHeight;
            const media = container.querySelector('.leftright-media');
            if (media && window.matchMedia('(min-width:1024px)').matches) {
                const mediaPicture = media.querySelector('picture');
                const pictureHeight = mediaPicture?.offsetHeight;

                if (container.classList.contains('extends-height')) {
                    mediaPicture.style.maxHeight = '984px';
                } else if (mediaPicture && pictureHeight < contentHeight) {
                    mediaPicture.style.maxHeight = `${contentHeight}px`;
                }
            }

            if (media) {
                this.bindVideoControls(media, index, containers);
            }
        });
    }

    bindVideoControls(media, currentContainerIndex, containers) {
        const video = media.querySelector('video');
        const blockId = video?.dataset.blockId
            ? parseInt(video.dataset.blockId, 10)
            : null;
        if (!blockId) {
            return;
        }
        const controls = document.querySelector(`#video-controls-${blockId}`);

        if (!video || !controls) {
            return;
        }

        const rewindButton = controls.querySelector('.control-rewind');
        const controlVolume = controls.querySelector('.control-volume');
        const controlMute = controlVolume.querySelector('.control-mute');
        const volumeBar = controls.querySelector('input.control-volume-bar');
        const volumeBarContainer = controls.querySelector('.volume-bar-container');

        let otherVideos = [];
        const otherContainers = Array.from(containers).filter((el, index) => index !== currentContainerIndex);
        if (otherContainers && otherContainers.length) {
            otherVideos = otherContainers.map((el) => el.querySelector('.leftright-media')?.querySelector('video'));
        }

        rewindButton?.addEventListener('click', () => {
            video.currentTime = 0;
            if (video.muted) {
                this.unmuteVideo(video, blockId);
                this.updateVolumeIcons(video.volume, blockId);
                this.muteVideos(otherVideos);
            }
        });

        controlMute?.addEventListener('click', () => {
            if (video.muted) {
                this.unmuteVideo(video, blockId);
                this.muteVideos(otherVideos);
            } else {
                this.muteVideo(video, blockId);
            }
            this.updateVolumeIcons(video.volume, blockId);
        });

        controlMute?.addEventListener('mouseenter', () => {
            if (volumeBarContainer) {
                volumeBarContainer.style.opacity = 1;
            }
        });

        controls?.addEventListener('mouseleave', () => {
            if (volumeBarContainer) {
                volumeBarContainer.style.opacity = 0;
            }
        });

        volumeBar?.addEventListener('change', () => {
            const volume = parseFloat(volumeBar.value);
            video.volume = volume;
            volumeBar.dataset.storedVolume = volume;

            const wasMuted = video.muted;
            video.muted = volume === 0;

            if (!video.muted && wasMuted) {
                this.muteVideos(otherVideos);
            }

            this.updateVolumeIcons(volume, blockId);
        });
    }

    updateVolumeIcons(volume, blockId) {
        const controls = document.querySelector(`#video-controls-${blockId}`);
        const muteContainer = controls?.querySelector('.control-volume .control-mute');

        const noVolume = muteContainer.querySelector('.no-volume');
        const halfVolume = muteContainer.querySelector('.volume-half');
        const fullVolume = muteContainer.querySelector('.volume-full');

        if (volume === 0) {
            this.showIcon(noVolume);
            this.hideIcon(halfVolume);
            this.hideIcon(fullVolume);
        } else if (volume < 0.5) {
            this.hideIcon(noVolume);
            this.showIcon(halfVolume);
            this.hideIcon(fullVolume);
        } else {
            this.hideIcon(noVolume);
            this.hideIcon(halfVolume);
            this.showIcon(fullVolume);
        }
    }

    showIcon(el) {
        el.classList.add('block');
        el.classList.remove('hidden');
    }

    hideIcon(el) {
        el.classList.add('hidden');
        el.classList.remove('block');
    }

    muteVideos(videos) {
        videos.forEach((video) => {
            if (!video) {
                return;
            }
            const blockId = video.dataset.blockId
                ? parseInt(video.dataset.blockId, 10)
                : null;
            if (blockId) {
                this.muteVideo(video, blockId);
                this.updateVolumeIcons(0, blockId);
            }
        });
    }

    muteVideo(video, blockId) {
        const volumeBar = document.querySelector(`#control-volume-bar-${blockId}`);
        volumeBar.dataset.storedVolume = video.volume;
        video.volume = 0;
        volumeBar.value = 0;
        video.muted = true;
    }

    unmuteVideo(video, blockId) {
        const volumeBar = document.querySelector(`#control-volume-bar-${blockId}`);
        const storedVolume = parseFloat(volumeBar?.dataset.storedVolume ?? '') || 1;
        video.volume = storedVolume;
        volumeBar.value = storedVolume;
        video.muted = false;
    }
}
